<template>

    <div v-if="!dataLoaded"><Loader/></div>

    <div class="create-courses" v-else>

        <div class="header-steps">
            <div class="step" :class="{'step--selected':stepSelected== 1}"><i class="material-icons" v-if="stepSelected>1">check_circle</i><span v-else>1</span><span>Distribución</span></div>
            <div class="step" :class="{'step--selected':stepSelected==2}"><i class="material-icons" v-if="stepSelected>2">check_circle</i><span v-else>2</span><span>Certificados</span></div>
            <div class="step" :class="{'step--selected':stepSelected==3}"><i class="material-icons" v-if="stepSelected>3">check_circle</i><span v-else>3</span><span>Cronograma</span></div>
            <div class="step" :class="{'step--selected':stepSelected==4}"><i class="material-icons" v-if="stepSelected>4">check_circle</i><span v-else>4</span><span>Confirmación</span></div>
        </div>

        <div v-if="stepSelected == 1" class="step-1">
            <div class="form-header">
                <h1>Crear cursos</h1>
                <h2>Paso 1</h2>
                <h3>Distribución de participantes</h3>
            </div>
            <div class="step-1__content">
                <div class="course-name">{{preinscriptionData.internalName}}</div>
                <h5>Esta cohorte tiene <span>{{preinscriptionData.studentStageTwo}} participantes inscriptos</span></h5>
                <div class="select-courseCfg">
                    <Select 
                        v-model="dataModel.courseCfgId"
                        mode="simple"
                        id="courseCfg"
                        label="Curso"
                        valueProp="courseCfgId"
                        valueLabel="courseCfgName"
                        :values="preinscriptionData.courses"
                        :isDropdown="true"
                    />
                </div>
                <!-- <div class="select-courseType">
                    <Select 
                        v-model="dataModel.courseType"
                        mode="simple"
                        id="courseType"
                        label="Tipo de curso"
                        valueProp="id"
                        valueLabel="name"
                        :values="formattedCourseTypes"
                        :isDropdown="true"
                        />

                </div> -->
                <div class="distribution" v-if="preinscriptionData.courseType == 0">
                    <div class="distribution__header">
                        <div class="distribution__header__title">PARÁMETROS DE DISTRIBUCIÓN</div>
                        <div class="distribution__header__edit" 
                            @click.stop="preinscriptionData.courseType == 1 ? openModalCoursesParams() : ''"
                            :class="{ 'disabled': preinscriptionData.courseType == 1 }">
                            Editar <i class="material-icons">edit</i>
                        </div>
                    </div>
                    <div class="distribution__box">
                        <div><h6>Cupo Máximo</h6><span>{{courseAmountModel.studentLimit}} participantes</span></div>
                        <div><h6>Cupo Mínimo</h6><span>{{courseAmountModel.studentMinLimit}} participantes</span></div>
                        <div><h6>Distribución</h6><span>
                            <!-- {{courseAmountModel.distribution == 'GENDER' ? 'Género' : courseAmountModel.distribution == 'COUNTRY' ? 'País' : 'Ambos'}} -->
                            -
                        </span></div>
                    </div>
                </div>
                <div class="courses" v-if="courseAmountModel.dataLoaded">
                    <div class="courses__header" v-if="preinscriptionData.courseType == 0">
                        <div class="courses__header__title">CANTIDAD DE CURSOS SUGERIDOS</div>
                        <div class="courses__header__quantity">
                            <i class="material-icons"
                            @click.stop="preinscriptionData.courseType == 0 && courseAmountModel.courseAmount ? courseAmountModel.courseAmount-- : ''; preinscriptionData.courseType == 0 ? getCourseAmount() : ''"
                            :class="{ 'disabled': preinscriptionData.courseType == 1 }"
                            >
                                remove_circle_outline
                            </i>
                            <span>{{courseAmountModel.courseAmount}}</span>
                            <i class="material-icons"
                            @click.stop="preinscriptionData.courseType == 0 ? courseAmountModel.courseAmount++ : ''; preinscriptionData.courseType == 0 ? getCourseAmount() : ''"
                            :class="{ 'disabled': preinscriptionData.courseType == 1 }"
                            >
                                add_circle_outline
                            </i>
                        </div>
                    </div>
                    <div class="invalid-box-info" v-if="courseAmountModel.courseAmount != courseAmountModel.suggestedCourseAmount && courseAmountModel.excess && preinscriptionData.courseType == 0">
                        <div><i class="material-icons">error</i></div>
                        <div>
                            <div class="invalid-box-info__title">{{courseAmountModel.excess == 'MIN' ? 'Cupo mínimo no cubierto' : 'Cupo máximo excedido'}}</div>
                            <div class="invalid-box-info__info" v-if="courseAmountModel.excess == 'MIN'">
                                Te sugerimos crear <b>{{courseAmountModel.suggestedCourseAmount}} {{courseAmountModel.suggestedCourseAmount == 1 ? 'grupo.' : 'grupos.'}}</b>
                            </div>
                            <div class="invalid-box-info__info" v-else>Te sugerimos crear al menos <b>{{courseAmountModel.suggestedCourseAmount}} grupos.</b></div>
                        </div>
                    </div>

                    <div class="courses__boxes">
                        <div class="courses__boxes__box" v-for="(course,index) in dataModel.courses" :key="index">
                            <div class="name"><h3>CURSO {{index+1}}</h3><h4>{{course.name}}</h4></div>
                            <div class="students-and-tutors">
                                <span class="students">{{course.studentAmount}} participantes</span>
<!--                                 <Multiselect
                                    v-model="course.tutors" :options="tutors" 
                                    placeholder="Tutores" trackBy="fullName" valueProp="id" label="fullName" 
                                    :closeOnSelect="false" :searchable="true" mode="tags">
                                </Multiselect>
 -->                            
                                <Select 
                                    v-model="course.tutors"
                                    mode="multi"
                                    :id="`createCoursesTutors-${index}`"
                                    label="Facilitadores"
                                    valueProp="id"
                                    valueLabel="fullName"
                                    :values="tutors"
                                    :isDropdown="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <template v-else>
                    <Loader />
                </template>
            </div>
            <div class="next-back-btns" v-if="courseAmountModel.dataLoaded">
                <button
                @click.stop="stepSelected = 2; scheduleModel.courseCfg = dataModel.courseCfgId; preinscriptionData.courseType != 1 ? autocompleteCourseCfgCertificateInfo() : ''"
                :disabled="dataModel.courses.some(course=>!course.tutors.length) && preinscriptionData.courseType == 0 || !dataModel.courseCfgId">
                    <span>Continuar</span><i class="material-icons">arrow_forward</i>
                </button>
            </div>
        </div>

        <div v-if="stepSelected == 2" class="step-2">
            <div class="form-header">
                <h1>Crear cursos</h1>
                <h2>Paso 2</h2>
                <h3>Certificados</h3>
            </div>
            <div class="step-2__content">
                <EmptyState icon="error" title="Los cursos On Demand no poseen certificación." v-if="preinscriptionData.courseType == 1" />
                <template v-else>
                    <div class="certificate-toggle">
                        <div class="certificate-toggle__title">
                            <span>
                                {{ dataModel.certification.hasCertification ? 'DESACTIVAR' : 'ACTIVAR' }}
                            </span>
                            CERTIFICACIÓN
                        </div>
                        <div
                        :class="{ active: dataModel.certification.hasCertification }"
                        class="toggle-button"
                        @click="toggleHasCertification()"
                        :style="{ opacity: dataModel.certification.hasCertification ? 1 : 0.5 }"
                        >
                            <div class="toggle-handle"></div>
                        </div>
                    </div>
    
                    <template v-if="dataModel.certification.hasCertification">
                        <div class="certificate-info">
                            <h4>CONDICIONES PARA CERTIFICAR</h4>
                            <div class="conditions">
                                <input type="number" v-model="dataModel.certification.mandatoryActivities" max="100" min="0" @input="validateMandatoryActivities()">
                                <label>% de actividades obligatorias entregadas</label>
                            </div> 
                            <div class="conditions">
                                <input type="checkbox" v-model="dataModel.certification.studentsPractice">
                                <label>Práctica con estudiantes</label>
                            </div>
                        </div>
                    </template>
    
                    <CustomCertificate
                        v-if="dataModel.certification.hasCertification"
                        v-model:certificateId="dataModel.certification.id" v-model:certificateType="dataModel.certification.certificateType"
                    />
    
                    <template>
                        <div @change="uploadFile($event)" class="upload-file__container" v-if="!dataModel.certification.file">
                            <label for="upload-file">{{ !dataModel.certification.fileUploading ? 'Subir un archivo' : 'Subiendo archivo' }}<i class="material-icons">file_upload</i></label>
                            <input :disabled="dataModel.certification.fileUploading" type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="" id="upload-file">
                        </div>
                        <div v-else class="file-tag">{{dataModel.certification.fileName}} <i class="material-icons" @click.stop="dataModel.certification.file = null">close</i> </div>
                    </template>

                </template>
                
            </div>
            <div class="next-back-btns">
                <button @click.stop="stepSelected = 1"><i class="material-icons">arrow_back</i><span>Atrás</span></button>
                <button @click.stop="stepSelected = 3" 
                :disabled="dataModel.certification.mandatoryActivities === '' || (dataModel.certification.certificateType == 'custom' && !dataModel.certification.file)">
                    <span>Continuar</span><i class="material-icons">arrow_forward</i>
                </button>
            </div>
        </div>

        <div v-if="stepSelected == 3" class="step-3">
            <div class="form-header">
                <h1>Crear cursos</h1>
                <h2>Paso 3</h2>
                <h3>Cronograma de los cursos</h3>
            </div>
            <div class="step-3__content">
                <div class="step-3__inputs-box">
                    <!-- <div class="input-w-label"><label>Fecha inicio del curso</label><input type="date" v-model="scheduleModel.courseStartDate" @change="getSchedule()"></div>-->
                     <div style="width: 50%;">
                         <DatePicker 
                             v-model="scheduleModel.courseStartDate"
                             label="Fecha de inicio del curso"
                             id="courseStartDate"
                             :from="new Date()"
                             @date-selected="getSchedule()"
                             :selectToday=true
                         />
                     </div>

                    <div class="interval-container" v-if="false">
                        <div class="input-w-label"><label>Intervalo de publicación</label><input type="number" placeholder="Ejemplo: 7" v-model="scheduleModel.publicationInterval"></div>
                        <span>El intervalo es en días.</span>
                    </div>
                </div>
                <template v-if="flase">
                    <h3>DÍAS DE SINCRÓNICO</h3>
                    <div class="step-3__inputs-box">
                        <Multiselect 
                            v-model="scheduleModel.syncDate" :options="weekDays" 
                            placeholder="Día" valueProp="id" label="name" 
                            :closeOnSelect="true" :searchable="false">
                        </Multiselect>
                        <div class="skip-holiday">
                            <input type="checkbox" v-model="scheduleModel.skipHolidays">
                            <label>Saltear feriados</label>
                        </div>
                    </div>
                </template>
                <button @click.stop="getSchedule()" v-if="false">Generar cronograma</button>
                <h3>CRONOGRAMA GENERAL</h3>
                <div class="schedule-info">
                   Desde aquí podrás visualizar las fechas de publicación y los encuentros sincrónicos.<br>Los cambios que apliques aquí afectaran a todos los cursos.<br>Podrás modificar cursos puntuales una vez creados los mismos. 
                </div>
                <div class="schedule">
                    <template v-if="scheduleModel.dataLoaded && dataModel.schedule">
                        <div class="unit" v-for="unit in dataModel.schedule.units" :key="unit.id">
                            <div class="unit__header"><div class="unit__name"><h4>{{'U'+ unit.orderNumber}}</h4>{{unit.name}}</div><h5>PUBLICACIÓN</h5><h5>SINCRÓNICO</h5></div>
                            <div class="module" v-for="mod in unit.modules" :key="mod.id">
                                <div class="module__name"><b>{{'MÓDULO '+ mod.orderNumber}}</b><i>{{mod.name}}</i></div>
                                <span class="module__date">{{formatDate(mod.publicationDate)}}</span>
                                <span class="module__date">{{mod.syncDate ? mod.syncDate : 'N/A'}}</span>
                            </div>
                        </div>
                    </template>
                    <Loader v-if="!scheduleModel.dataLoaded" />
                </div>

            </div>
            <div class="next-back-btns">
                <button @click.stop="stepSelected = 2"><i class="material-icons">arrow_back</i><span>Atrás</span></button>
                <button @click.stop="stepSelected = 4" :disabled="!dataModel.schedule"><span>Continuar</span><i class="material-icons">arrow_forward</i></button>
            </div>
        </div>

        <div v-if="stepSelected == 4" class="step-4">
            <template v-if="!creatingCourses">
                <div class="form-header">
                    <h1>Crear cursos</h1>
                    <h2>Paso 4</h2>
                    <h3>Confirmación</h3>
                </div>
                <div class="step-4__content">
                    <div class="step-4__info">
                        <span>Confirmas la creación de</span>
                        <b>{{dataModel.courses.length}} curso<template v-if="dataModel.courses.length > 1">s</template> 
                        {{ preinscriptionData.courses.find(el => el.courseCfgId == dataModel.courseCfgId)?.courseCfgName }},</b>
                        <span>para <b>{{preinscriptionData.studentStageTwo}} participantes</b> con las siguientes características:</span>
                    </div>

                    <div class="step-4__courses">
                        <div class="course" v-for="(course, index) in dataModel.courses" :key="index">
                            <div class="course__name">CURSO {{index+1}} <span>{{course.name}}</span></div>
                            <div class="course__info">
                                <div>{{course.studentAmount}} participantes</div>
                                <div class="tutor">
                                    <!-- if tutor doesn't exist -->
                                    <div v-if="!course.tutors.length"><b>Facilitador/a</b> No asignado</div>
                                    <div v-else><b>Facilitador/a</b>{{ tutors.find(el => el.id == course.tutors[0]).fullName }}</div>
                                    <div @mouseover="course.coordinatorTooltip = true" @mouseleave="course.coordinatorTooltip = false" v-if="course.tutors.length > 1" class="referent_plus">
                                        {{ `+${course.tutors.length - 1}` }}
                                        <Tooltip 
                                            v-if="course.coordinatorTooltip"
                                            color="#000"
                                            title="Facilitadores" 
                                            :list="course.tutors.map(id => tutors.find(el => el.id === id).fullName)"
                                        />
                                    </div>
                                </div>
                                <!-- <div class="type">
                                    <div>
                                        <b>Tipo de curso</b>
                                        <span>{{dataModel.courseType == "0" ? 'Regular' : 'On demand'}}</span>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>

                    <div class="step-4__schedule">
                        <div class="header">
                            <h3>CRONOGRAMA GENERAL<!--<i class="material-icons">info</i>--></h3>
                            <span @click.stop="stepSelected = 3">Editar <i class="material-icons">edit</i></span>
                        </div>
                        <div class="info">
                            <div>
                                <div class="item"><b>Inicio del curso</b><span>{{formatDate(scheduleModel.courseStartDate)}}</span></div>
                                <div class="item"><b>Primer sincrónico</b><span>N/A</span></div>
                                <!-- <div class="item"><b>Intervalo de publicación</b><span>7 días</span></div> -->
                            </div>
                            <!-- <div><button>Ver cronograma general</button></div> -->
                        </div>
                    </div>

                    <div class="step-4__certification">
                        <div class="header">
                            <h3>CERTIFICACIÓN</h3>
                            <span @click.stop="stepSelected=2">Editar <i class="material-icons">edit</i></span>
                        </div>
                        <div class="info">
                            <div class="item"><b>Condiciones para certificar</b>
                                <span v-if="dataModel.certification.mandatoryActivities == 0">No hay condiciones para certificar</span>
                                <span v-else>{{dataModel.certification.mandatoryActivities}}% actividades obligatorias entregadas</span>
                            </div>
                            <div class="item">
                                <b>Certificado</b>
                                <span v-if="!dataModel.certification.hasCertification">Certificación desactivada</span>
                                <span v-else>{{dataModel.certification.certificateType}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="next-back-btns">
                    <button @click.stop="stepSelected = 3"><i class="material-icons">arrow_back</i><span>Atrás</span></button>
                    <button @click.stop="createCourses()"><span>Crear cursos</span><i class="material-icons">arrow_forward</i></button>
                </div>
            </template>
            <template v-else>
                <h2>Creando cursos...</h2>
                <loader  />
            </template>
        </div>


        <div class="modal__overlay" v-if="modalCoursesParams.active">
            <div class="modal-params">
                <h3>Editar parámetros de distribución</h3>
                <label>CUPO MÁXIMO POR CURSO</label>
                <input type="number" v-model="modalCoursesParams.studentLimit">
                <label>CUPO MINIMO POR CURSO</label>
                <input type="number" v-model="modalCoursesParams.studentMinLimit">
                <!-- <h4>PARÁMETROS DE DISTRIBUCIÓN</h4>
                <div><input type="radio" name="param" value="GENDER" v-model="modalCoursesParams.distribution">Género</div>
                <div><input type="radio" name="param" value="COUNTRY" v-model="modalCoursesParams.distribution">País</div>
                <div><input type="radio" name="param" value="GENDERANDCOUNTRY" v-model="modalCoursesParams.distribution">Ambos</div> -->
                <div class="btns">
                    <button @click.stop="modalCoursesParams.active = false"><i class="material-icons">arrow_back</i>Atrás</button>
                    <button @click.stop="saveCoursesParams()">Continuar<i class="material-icons">arrow_forward</i></button>
                </div>
            </div>
        </div>

        <div class="modal__overlay" v-if="false">
            <div class="modal-schedule">
                <h3>Editar cronograma</h3>
                <div class="unit"><b>UNIDAD 2</b>Orientación vocacional</div>
                <div class="modules">
                    <div class="module" v-for="mod in dataModel.schedule.unit[modalSchedule].modules" :key="mod.id">
                        <h4>MÓDULO {{mod.orderNumber}}</h4>
                        <div class="date">
                            <label>Publicación</label>
                            <input type="date">
                        </div>
                        <div class="date">
                            <label>Sincrónico</label>
                            <input v-if="mod.orderNumber == 2" type="date">
                            <span v-else class="add">Agregar<i class="material-icons">add</i></span>
                        </div>
                        <div class="remove">Quitar<i class="material-icons">clear</i></div>
                    </div>
                </div>

                <div class="btns">
                    <button @click.stop="modalSchedule = false">Cancelar</button>
                    <button>Guardar<i class="material-icons">arrow_forward</i></button>
                </div>
            </div>
        </div>

        <div class="modal__overlay" v-if="modalOnDemand">
            <div class="modal-onDemand">
                <i class="material-icons close" @click="modalOnDemand =  false">close</i>
                <i class="material-icons check">check_circle</i>
                <h3>Inscripción On Demand creada con éxito.</h3>
                <p>A continuación, deberás <strong>crear una instancia de curso.</strong></p>
                <button @click="modalOnDemand =  false">
                    Crear instancia de curso
                    <i class="material-icons">arrow_forward</i>
                </button>
            </div>
        </div>

    </div>

</template>

<script setup>
import Loader from '../../components/Loader.vue';
//import Multiselect from '@vueform/multiselect';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import storage from "@/plugins/azure-storage";
import Select from '@/components/Inputs/Select.vue';
import DatePicker from '@/components/Inputs/DatePicker.vue';
import Tooltip from '@/components/ToolTip.vue';
import CustomCertificate from '../../components/CustomCertificate.vue';
import EmptyState from '@/components/EmptyState.vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const formatDate = inject('formatDate');
const tutors = ref();
const preinscriptionData = ref();
const dataLoaded = ref(false);
const stepSelected = ref(1);
const modalOnDemand = ref(false);
const weekDays = [{id:1, name: 'Lunes'},{id:2, name: 'Martes'},{id:3, name: 'Miércoles'},
{id:4, name: 'Jueves'},{id:5, name: 'Viernes'},{id:6, name: 'Sábado'},{id:7, name: 'Domingo'}];
const validateMandatoryActivities = ()=>{
    if(dataModel.value.certification.mandatoryActivities>100) dataModel.value.certification.mandatoryActivities = 100;
    if(dataModel.value.certification.mandatoryActivities<0) dataModel.value.certification.mandatoryActivities = 0;
}

const courseAmountModel = ref({
    preinscriptionId: route.params.preinscriptionId,
    studentLimit: 60,
    studentMinLimit: 30,
    distribution: 'GENDER',
    courseAmount: null,
    dataLoaded: false
})

const modalCoursesParams = ref({
    active: false,
    studentLimit: null,
    studentMinLimit : null,
    //distribution: null
})
function openModalCoursesParams(){
    modalCoursesParams.value.studentLimit = courseAmountModel.value.studentLimit;
    modalCoursesParams.value.studentMinLimit = courseAmountModel.value.studentMinLimit;
    modalCoursesParams.value.distribution = courseAmountModel.value.distribution;
    modalCoursesParams.value.active = true;
}
function saveCoursesParams(){
    courseAmountModel.value.studentLimit = modalCoursesParams.value.studentLimit;
    courseAmountModel.value.studentMinLimit = modalCoursesParams.value.studentMinLimit;
    courseAmountModel.value.distribution = modalCoursesParams.value.distribution;
    courseAmountModel.value.courseAmount = null;
    modalCoursesParams.value.active = false;
    getCourseAmount();
}

async function getTutors(){
    try {
        //tutors.value = [{id: 1, fullName: 'Roberto Carlos'},{id: 2, fullName: 'Lali Esposito'},{id: 3, fullName: 'Michael jordan'},{id: 4, fullName: 'Osama Binladen'}]
        let req = await store.dispatch('stuff_tutors')
        tutors.value =  req.data;
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', { text: 'Error al cargar datos de facilitadores' });
    }
}

async function getPreinscriptionData(){
    let req = await store.dispatch('preInscription_getPreInscriptionResume',route.params.preinscriptionId);
    preinscriptionData.value = req.data;
    if(preinscriptionData.value.courses.length === 1) dataModel.value.courseCfgId = preinscriptionData.value.courses[0].courseCfgId
    if(preinscriptionData.value.courseType == 1) courseAmountModel.value.courseAmount = 1;
}


// async function getCourseTypeOptions(){
//     try {
//         let req = await store.dispatch('preInscription_getCourseTypeOptions');
//         preinscriptionData.value.courseType = req.data;

//     } catch (error) {
//         console.log(error)
//         store.dispatch('notifications_create', { text: 'Error al obtener tipos de curso' })
//     }
// }

// const formattedCourseTypes = computed(() => {
//   return preinscriptionData.value.courseType.map(type => ({
//     id: type.id,
//     name: type.name.replace('_', ' ').toLowerCase().replace(/\b[a-z]/g, char => char.toUpperCase())  // This will format "ON_DEMAND" to "On Demand"
//   }));
// });





async function autocompleteCourseCfgCertificateInfo(){
    try {
        let req = await store.dispatch('preInscription_getPreInscriptionCourseCfgCertificateInfo', dataModel.value.courseCfgId);
        dataModel.value.certification.mandatoryActivities = req.data.percentageToCertificate;
        dataModel.value.certification.studentsPractice = req.data.needFinalPractice;
    } catch (error) {
        console.log(error)
    }
}

const dataModel = ref({
    preInscriptionId:  route.params.preinscriptionId,
    certification: {
        hasCertification: true,
        id: null,
        mandatoryActivities: '',
        studentsPractice:  true,
        file: null,
        certificateType: 'default',
    },
    courseCfgId: null,
    startDate: null,
    // courseType: null,
})



const toggleHasCertification = async () => {
    // change dataModel.certification.hasCertification value
    dataModel.value.certification.hasCertification = !dataModel.value.certification.hasCertification;
    
    if (!dataModel.value.certification.hasCertification) {
        dataModel.value.certification.id = null;
        dataModel.value.certification.studentsPractice = false;
        dataModel.value.certification.mandatoryActivities = 0;
        dataModel.value.certification.file = null;
        dataModel.value.certification.certificateType = 'default';

        // autocomplete autocompleteCourseCfgCertificateInfo
    } else {
        await autocompleteCourseCfgCertificateInfo();
    }
}


async function getCourseAmount(){
    try {
        courseAmountModel.value.dataLoaded = false;   
        let req = await store.dispatch('coursesInstances_courseAmount', courseAmountModel.value);
        dataModel.value.courses = req.data.courses; 
        dataModel.value.courses.forEach(course => course.tutors = []);
        courseAmountModel.value.courseAmount = req.data.courseAmount;
        courseAmountModel.value.suggestedCourseAmount = req.data.suggestedCourseAmount;
        courseAmountModel.value.excess = req.data.excess;
        courseAmountModel.value.dataLoaded = true;
    } catch (error) {
        console.log(error)
        store.dispatch('notifications_create', {text: 'Error al obtener datos de cursos'})      
    }
}


const scheduleModel = ref(
    {
        preInscriptionId: route.params.preinscriptionId,
        courseStartDate: null,
        //publicationInterval: null,
        //syncDate: null,
        //skipHolidays: false,
        dataLoaded: true,
        // courseType: dataModel.value.courseType
    }
)

/*
//La edición del cronograma la dejamos para la siguiente versión
//Pero ya está hecha la maqueta del modal en el html
const modalSchedule = ref(null);
function openModalSchedule(){}
*/

async function getSchedule(){
    try {
        scheduleModel.value.dataLoaded = false;   
        dataModel.value.schedule = null;
        // scheduleModel.value.courseType = dataModel.value.courseType;
        let req = await store.dispatch('coursesInstances_schedule', scheduleModel.value);
        dataModel.value.schedule = req.data;
        dataModel.value.startDate = scheduleModel.value.courseStartDate;
        scheduleModel.value.dataLoaded = true;
    } catch (error) {
        console.log(error)
        store.dispatch('notifications_create', {text: 'Error al obtener cronograma'})
    }
}

async function uploadFile(event) {
    let file = event.target.files[0];
    if(!file) return false;
    if (file.size > 629145600) {
        store.dispatch('notifications_create',{text:'Error. El archivo es superior a 600MB'});
        return false;
    }
    dataModel.value.certification.fileUploading = true;
    try {
        let fileCDN = await storage.updateFile(file,'content');
        dataModel.value.certification.file = fileCDN;
        dataModel.value.certification.fileName = file.name;
    } 
    catch (error) {
        console.log(error);
        store.dispatch('notifications_create', { text:'Error al intentar subir archivo' });
    }
    finally {
        dataModel.value.certification.fileUploading = false; 
    }
}

const creatingCourses = ref(false);
async function createCourses(){
    try {
        creatingCourses.value = true;
        await store.dispatch('coursesInstances_createCourses', dataModel.value);
        router.push('/management/courses')
    } catch (error) {
        console.log(error)
        store.dispatch('notifications_create', { text: 'Error al crear cursos' })
        creatingCourses.value = false;
    }
}

async function getInitialData(){
    try {
        await getPreinscriptionData();
        // await getCourseTypeOptions();
        await getTutors();
        await getCourseAmount();
        dataLoaded.value = true;                
    } catch (error) {
        console.log(error)
        store.dispatch('notifications_create', { text: 'Error al obtener datos iniciales' })
    }
}

onMounted(async()=>{
    await getInitialData();
    if(preinscriptionData.value.courseType == 1){
        //dataModel.value.certification.hasCertification = false;
        toggleHasCertification();
        modalOnDemand.value = true;  
    } 
})

</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.certificate-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    .certificate-toggle__title {
        font-size: 13px;
        font-weight: 700;
        color: $green;
    }

    .toggle-button {
        width: 40px;
        height: 16px;
        background-color: #ccc;
        border-radius: 15px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .toggle-button.active {
        background-color: #9ed7d7;
    }

    .toggle-handle {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        transition: all 0.3s;
    }

    .active{
        .toggle-handle {
            transform: translateX(22px);
            background-color: $green;
        }
    }
}

.certificate-info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
}


.create-courses{
    width: 100%;
    min-height: 100vh;
    padding-bottom: 49px;
    @include flex-column;
    background: #fff;
}

.header-steps{
    width: 100%;
    margin-bottom: 32px;
    height: 86px;
    padding-bottom: 18px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 42px;
    border-bottom: 1px solid #D9D9D9;
    background: #fff;
    .step{
        @include icon-and-text-container;
        span:first-child{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 28px;
            height: 28px;
            border-radius: 100%;
            background: #BDBDBD;
            color: #fff;
            font-size: 11px;
            font-weight: 700;
            line-height: 28px;
        }
        span:last-child{
            font-size: 13px;
            font-weight: 600;
            color: #BDBDBD;
        }
        &--selected{
            span:first-child{
                background: #FFB23F;
                color: #212121;
            }
            span:last-child{
                color: #212121;
            }
        }
        .material-icons{
            color: #77C991;
            font-size: 29px
        }
        @media screen and (max-width: 800px){
            display: none;
            &.step--selected{
                display: flex;
            }
        }
    }
}

.form-header{
    @include flex-column;
    gap: 12px;
    h1{
        font-size: 24px;
        font-weight: 800;
    }
    h2{
        font-size: 14px;
        font-weight: 800;
    }
    h3{
        font-size: 20px;
        font-weight: 600;
    }
}

@mixin btn-continue{
    padding: 10px 28px;
    @include icon-and-text-container;
    justify-content: center;
    background: $green;
    border-radius: 44px;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    .material-icons{
        font-size: 18px;
    }
}
@mixin btn-back{
    padding: 10px 28px;
    @include icon-and-text-container;
    justify-content: center;
    //background: $green;
    border: 1px solid $green;
    border-radius: 44px;
    color: $green;
    font-weight: 600;
    font-size: 16px;
    .material-icons{
        font-size: 18px;
    }
}

.next-back-btns{
    width: 100%;
    padding-top: 42px;
    display: flex;
    justify-content: center;
    gap: 24px;
    button:first-child{
        @include btn-back;
    }
    button:last-child{
        @include btn-continue;
        &:disabled{
            opacity: .6;
            cursor: default;
        }
    }
}

@mixin shadow-box{
    padding: 0 32px;
    box-shadow: 5px 5px 35px rgba(217, 217, 217, 0.5);
    border-radius: 10px;
    background: #fff;
}

input[type="text"],input[type="number"],input[type="date"]{
    height: 40px;
    padding: 0 12px;
    background: #F6F6F6;
    border-radius: 50px;
    border: none;
}

.input-w-label{
    height: 46px;
    padding-right: 8px;
    padding-left: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F6F6F6;
    border-radius: 50px;
    border: none;
    label{
        padding-right: 6px;
        background: #F6F6F6;
        font-size: 13px;
        font-weight: 400;
    }
    input{
        background: #F6F6F6;
        border: none;
        flex-grow: 1;
    }
}

.step-1{
    width: 98vw;
    max-width: 500px;
    &__content{
        padding: 12px 0;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .course-name{
            font-style: italic;
            font-weight: 700;
            font-size: 18px;
            color: $green;
            text-align: center;
        }
        h5{
            width: 100%;
            margin: 10px 0;
            font-weight: 600;
            font-size: 15px;
            span{
                color: $green;
            }
        }
        .select-courseCfg {
            width: 100%;
            max-width: 380px;
            margin: 0 auto;
        }
        // .select-courseType {
        //     width: 100%;
        //     max-width: 380px;
        //     margin: 0 auto;
        // }
        .distribution{
            &__header{
                display: flex;
                justify-content: space-between;
                margin-bottom: 14px;
                &__title{
                    font-weight: 700;
                    font-size: 12px;
                }
                &__edit{
                    @include icon-and-text-container;
                    gap: 4px;
                    font-weight: 600;
                    font-size: 12px;
                    color: $green;
                    cursor: pointer;
                    .material-icons{
                        font-size: 14px;
                    }
                }
            }
            &__box{
                @include shadow-box;
                height: 100px;
                display: flex;
                justify-content: space-between;
                div{
                    @include flex-column;
                    justify-content: center;
                    gap: 4px;
                    h6{
                        font-size: 12px;
                        font-weight: 600;
                    }
                    span{
                        font-size: 12px; 
                        font-weight: 400;
                    }
                }
            }
        }
        .courses{
            &__header{
                margin-bottom: 14px;
                display: flex;
                align-items: center;
                gap: 14px;
                &__title{
                    font-weight: 700;
                    font-size: 12px;
                }
                &__quantity{
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    .material-icons{
                        color: $green;
                        cursor: pointer;
                    }
                    span{
                        font-weight: 700;
                        font-size: 12px; 
                    }
                }
            }
            &__boxes{
                @include shadow-box;
                &__box{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    gap: 4px;
                    border-bottom: 1px solid #D9D9D9;
                    padding: 24px 0;
                    &:last-child{
                        border: none;
                    }
                    .name{
                        display: flex;
                        gap: 4px;
                        h3{
                            font-weight: 700;
                            font-size: 12px;                        
                        }
                        h4{
                            font-weight: 400;
                            font-size: 12px;   
                            color: $green;                     
                        }
                    }
                    .students-and-tutors{
                        padding-top: 6px;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        gap: 12px;
                        .students{
                            width: fit-content;
                            white-space: nowrap;
                            font-weight: 400;
                            font-size: 12px;
                            padding-top: 18px; 
                        }
                    }
                }
            }
        }
        .loader__container{
            height: 160px;
        }
    }
    .invalid-box-info{  
        margin: 16px 0;
        padding: 14px 20px;
        display: flex;
        align-items: stretch;
        background: rgba(255, 189, 176, 0.5);;
        >div{
            display: flex;
            flex-direction: column;
            &:first-child{
                width: fit-content;
                .material-icons{
                    padding-right: 6px;
                    color: $red;
                }
            }
            &:last-child{
                flex-grow: 1;
                gap: 12px;
                font-size: 14px;
            }
        }
        &__title{
            padding-top: 2px;
            font-weight: 700;
            color: $red;
        }
        &__info{
            font-weight: 500;
        } 
    }
}

@mixin modalStyle{
    position: relative;
    padding: 26px 32px;
    background: #FFFFFF;
    box-shadow: 5px 5px 35px rgba(217, 217, 217, 0.5);
    border-radius: 10px;
    .close{
        position: absolute;
        right: 8px;
        top: 8px;
        cursor: pointer;
    }
    .check{
        color: $green;
        font-size: 32px;
    }
}

.modal-onDemand{
    @include modalStyle;
    padding-top: 32px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;

    h3{
        font-size: 18px;
        font-weight: 700;
    }
    p{
        font-size: 16px;
        font-weight: 400;

        strong {
            font-weight: 600;
        }
    }
    button {
        background: $green;
        color: #fff;
        padding: 10px 36px;
        border-radius: 44px;
        font-weight: 600;
        font-size: 16px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: fit-content;
    }
}

.modal-params{
    @include modalStyle;
    display: flex;
    flex-direction: column;
    gap: 14px;
    h3{
        margin-bottom: 4px;
        font-weight: 700;
        font-size: 16px;    
    }
    label{
        font-weight: 700;
        font-size: 12px;    
    }
    h4{
        margin-top: 4px;
        font-weight: 700;
        font-size: 13px;    
    }
    div{
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 600;
        input{
            height: fit-content;
        }
    }
    .btns{
        padding-top: 12px;
        justify-content: center;
        gap: 18px;
        button{
            @include btn-continue;
            &:first-child{
                background: #fff;
                color: $green;
                padding: 10px 36px;
                border: 1px solid $green;
            }
        }
    }
}

.modal-schedule{
    @include modalStyle;
    display: flex;
    flex-direction: column;
    gap: 22px;
    h3{
        font-size: 16px;
        font-weight: 700;
    }
    .unit{
        display: flex;
        gap: 4px;
        font-size: 15px;
        font-weight: 400;
        color: $green;
        b{
            font-weight: 700;
        }
    }
    .module{
        border-bottom: 1px solid #D9D9D9;
        padding-bottom: 16px;
        margin-bottom: 18px;
        &:last-child{
            border: none;
            margin: 0;
        }
        h4{
            margin-bottom: 4px;
            font-size: 13px;
            font-weight: 700;
        }
        .date{
            display: flex;
            align-items: center;
            gap: 62px;
            label{
                width: 76px;
                font-size: 13px;
                font-weight: 400;
            }
            input{
                margin: 6px 0;
                width: 170px;
            }
            .add{
                margin: 14px 0;
                padding-left: 12px;
                @include icon-and-text-container;
                font-size: 13px;
                font-weight: 600;
                color: $green;
                cursor: pointer;
                .material-icons{
                    font-size: 16px;
                }
            }
        }
        .remove{
            @include icon-and-text-container;
            justify-content: flex-end;
            font-size: 13px;
            font-weight: 600;
            color: $green;
            cursor: pointer;
            .material-icons{
                font-size: 14px;
            }
        }
    }
    .btns{
        display: flex;
        padding-top: 4px;
        justify-content: center;
        gap: 18px;
        button{
            @include btn-continue;
            &:first-child{
                background: #fff;
                color: $green;
                padding: 10px 36px;
                border: 1px solid $green;
            }
        }
    }
}

.step-2{
    width: 100%;
    max-width: 800px;
    &__content{
        padding-top: 12px;
        display: flex;
        flex-direction: column;
        gap: 22px;
        background: #fff;
        h4{
            margin-top: 20px;
            font-size: 13px;
            font-weight: 700;
        }
        label{
            font-size: 13px;
            font-weight: 600;
        }
        .conditions{
            display: flex;
            align-items: center;
            gap: 12px;
            input{
                width: 80px;
            }
        }
        .upload-file__container{
            #upload-file{
                visibility: hidden;
                position: absolute;
                width: 0px;
                height: 0px;
                top: 0;
                left: 0;
            }
            label{
                margin: 16px 0;
                padding: 11px 14px;
                display: inline-flex;
                align-items: center;
                gap: 4px;
                border: 1px solid $green;
                border-radius: 44px;
                color: $green;
                font-size: 15px;
                font-weight: 600;
                cursor: pointer;
                .material-icons{
                    color: $green;
                    font-size: 22px;
                }
            }
        }
        .file-tag{
            width: fit-content;
            margin: 16px 0;
            padding: 11px 14px;
            display: flex;
            align-items: center;
            gap: 22px;
            border: 1px solid;
            border-radius: 44px;
            font-size: 15px;
            font-weight: 500;
            .material-icons{
                font-size: 22px;
                cursor: pointer;
            }
        }
    }
}

.step-3{
    &__content{
        padding-top: 32px;
        display: flex;
        flex-direction: column;
        //gap: 16px;
        h3{
            margin: 12px 0 12px 22px;
            font-weight: 700;
            font-size: 13px;        
        }
    }
    .multiselect,.input-w-label{
        width: 295px;
        margin: 0;
        input[type="number"]{
            width: 100px;
        }
    }
    &__inputs-box{
        margin-bottom: 18px;
        display: flex;
        gap: 36px;
        justify-content: center;
        .interval-container{
            display: flex;
            flex-direction: column;
            gap: 4px;
            span{
                padding-left: 22px;
                font-weight: 600;
                font-size: 10px;
            }
        }
        .skip-holiday{
            padding-left: 4px;
            @include icon-and-text-container;
        }
    }
    .schedule-info{
        padding-left: 22px;
        font-weight: 400;
        font-size: 14px;    
    }
    .schedule{
        width: 656px;
        margin-top: 22px;
        display: flex;
        flex-direction: column;
        gap: 14px;
        *{color: black;}
        .unit{
            @include shadow-box;
            padding: 20px 22px 4px 22px;
            border-radius: 10px;
            color: #fff;
            &__header{
                padding-bottom: 8px;
                display: flex;
                //justify-content: space-between;
                h5{
                    width: 140px;
                    font-size: 13px;
                    font-weight: 700;
                    color: black;
                }
            }
            &__name{
                flex-grow: 1;
                display: flex;
                gap: 3px;
                font-size: 13px;
                font-weight: 400;
                color: $green;
                h4{
                    font-weight: 700;
                    color: $green;
                }
            }
        }
        .module{
            padding: 18px 0;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #D9D9D9;
            &:last-child{
                border: none;
            }
            &__name{
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                gap: 4px;
                font-size: 13px;
                i{                    
                    width: 226px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-style: normal;
                }
            }
            span{
                width: 140px;
            }
            &__date{
                padding-left: 2px;
                font-size: 13px;
                font-weight: 600;
            }
            .edit{
                width: 80px;
                @include icon-and-text-container;
                justify-content: center;
                color: $green;
                font-size: 13px;
                font-weight: 500;
                cursor: pointer;
                .material-icons{
                    color: $green;
                    font-size: 16px;
                }
            }
        }
    }
}

.step-4{
    &__content{
        padding-top: 32px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
    &__info{
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 19px;
        font-weight: 400;
        b{
            font-weight: 700;
        }
    }
    &__courses{
        @include shadow-box;
        display: flex;
        flex-direction: column;
        .course{
            padding: 22px 0;
            display: flex;
            flex-direction: column;
            gap: 12px;
            border-bottom: 1px solid #D9D9D9;
            &:last-child{
                border: none;
            }
            &__name{
                font-size: 12px;
                font-weight: 700;
                span{
                    padding-left: 6px;
                    font-weight: 400;
                    color: $green;
                }
            }
            &__info{
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                align-items: center;
                font-size: 12px;
                .tutor{
                    display: flex;
                    align-items: center;
                    gap: 22px;
                    >div{
                        display: flex;
                        flex-direction: column;
                    }
                }
                .type{
                    display: flex;
                    align-items: center;
                    gap: 22px;
                    >div{
                        display: flex;
                        flex-direction: column;
                    }
                }
                .referent_plus{
                    font-weight: 700;
                    font-size: 16px;
                    color: $green;
                    cursor: pointer;
                }
            }

        }
    }
    &__schedule,&__certification{
        .header{
            margin-bottom: 12px;
            padding: 0 2px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            h3{
                @include icon-and-text-container;
                font-size: 12px; 
                font-weight: 700;
                .material-icons{
                    color: $green;
                    font-size: 18px;
                }
            }
            span{
                @include icon-and-text-container;
                font-size: 12px; 
                font-weight: 600;
                color: $green;
                cursor: pointer;
                .material-icons{
                    color: $green;
                    font-size: 14px;
                }
            }
        }
        .info{
            @include shadow-box;
            padding: 32px;
            > div {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
            }
            .item{
                display: flex;
                flex-direction: column;
                gap: 8px;
                font-size: 12px;
                font-weight: 400;
                b{
                    font-weight: 700;
                }
            }
        }
    }
    &__schedule{
        .info{
            >div{
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                button{
                    margin-top: 28px;
                    font-size: 12px;
                    font-weight: 600;
                    color: $green;
                }            
            }
        }
    }
    &__certification{
        .info{
            display: grid;
            grid-template-columns: 2fr 1fr;
        }
    }
}

</style>